import _startCase from "lodash/startCase";
import { type SearchIndex } from "algoliasearch";

export async function checkReplicaIndices(
  parentIndex: SearchIndex,
  sortingList: {
    sortingAttribute: string;
    sortingLabel: string;
  }[]
): Promise<string[] | null> {
  try {
    // Return null if no sorting list in Prismic
    if (!sortingList?.length) return null;

    const { replicas = [] } = await parentIndex.getSettings();

    const prismicReplicaValues = sortingList
      .filter(
        ({ sortingAttribute, sortingLabel }) => sortingAttribute || sortingLabel
      )
      .map(({ sortingAttribute }) =>
        sortingAttribute
          ? `${parentIndex.indexName}_${sortingAttribute}`
          : parentIndex.indexName
      );

    // Algolia replicas are prefixed with "virtual" and wrapped in parentheses
    // The index name is formatted with the parent index name and sorting attribute
    // e.g. virtual(products_uk_price_desc)
    const transformedReplicas = replicas.map((r) =>
      r.replace(/^virtual\((.*?)\)$/, "$1")
    );
    const matchedReplicas = transformedReplicas.filter((r) =>
      prismicReplicaValues.includes(r)
    );

    // Include parent index if Prismic attribute field empty but label exists.
    // The Algolia parent index is driving bestsellers/most popular book sorting option.
    if (
      prismicReplicaValues.includes(parentIndex.indexName) &&
      !matchedReplicas.includes(parentIndex.indexName)
    ) {
      matchedReplicas.push(parentIndex.indexName);
    }
    return matchedReplicas.length > 0 ? matchedReplicas : null;
  } catch (err) {
    console.error({
      err: `Error fetching index settings. ${err}`,
    });
    return null;
  }
}

export function filterOptions(taxonQuery: string): string {
  if (!taxonQuery) {
    return "";
  }

  // Format needed for Algolia filters
  return `(productCatalogueCategories:"${taxonQuery}")`;
}

export function formatQuery(str: string): string {
  switch (str) {
    case str.match(/\b\d+-\d+\b/)?.[0]:
      return str;
    case "mothers-day":
      return "Mother's Day"; // Annoying hack to add an apostrophe
    case "fathers-day":
      return "Father's Day"; // See above
    case "wedding-engagement":
      return "Wedding and Engagement"; // See above too
    default:
      return _startCase(str.replaceAll("-", " "));
  }
}
